module.exports = __webpack_public_path__ + "static/boticario-4713426dca06591f5ab85d9bc2e36a72.jpg";